// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Quicksand:400,700,400italic,700italic);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400italic,700italic,400,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Sky theme for reveal.js.
 *
 * Copyright (C) 2011-2012 Hakim El Hattab, http://hakim.se
 */
.reveal a {
  line-height: 1.3em;
}

section.has-dark-background, section.has-dark-background h1, section.has-dark-background h2, section.has-dark-background h3, section.has-dark-background h4, section.has-dark-background h5, section.has-dark-background h6 {
  color: #fff;
}

/*********************************************
 * GLOBAL STYLES
 *********************************************/
:root {
  --r-background-color: #f7fbfc;
  --r-main-font: Open Sans, sans-serif;
  --r-main-font-size: 40px;
  --r-main-color: #333;
  --r-block-margin: 20px;
  --r-heading-margin: 0 0 20px 0;
  --r-heading-font: Quicksand, sans-serif;
  --r-heading-color: #333;
  --r-heading-line-height: 1.2;
  --r-heading-letter-spacing: -0.08em;
  --r-heading-text-transform: uppercase;
  --r-heading-text-shadow: none;
  --r-heading-font-weight: normal;
  --r-heading1-text-shadow: none;
  --r-heading1-size: 3.77em;
  --r-heading2-size: 2.11em;
  --r-heading3-size: 1.55em;
  --r-heading4-size: 1em;
  --r-code-font: monospace;
  --r-link-color: #3b759e;
  --r-link-color-dark: #264c66;
  --r-link-color-hover: #74a7cb;
  --r-selection-background-color: #134674;
  --r-selection-color: #fff;
  --r-overlay-element-bg-color: 0, 0, 0;
  --r-overlay-element-fg-color: 240, 240, 240;
}

.reveal-viewport {
  background: #add9e4;
  background: -moz-radial-gradient(center, circle cover, #f7fbfc 0%, #add9e4 100%);
  background: -webkit-gradient(radial, center center, 0px, center center, 100%, color-stop(0%, #f7fbfc), color-stop(100%, #add9e4));
  background: -webkit-radial-gradient(center, circle cover, #f7fbfc 0%, #add9e4 100%);
  background: -o-radial-gradient(center, circle cover, #f7fbfc 0%, #add9e4 100%);
  background: -ms-radial-gradient(center, circle cover, #f7fbfc 0%, #add9e4 100%);
  background: radial-gradient(center, circle cover, #f7fbfc 0%, #add9e4 100%);
  background-color: var(--r-background-color);
}

.reveal {
  font-family: var(--r-main-font);
  font-size: var(--r-main-font-size);
  font-weight: normal;
  color: var(--r-main-color);
}

.reveal ::selection {
  color: var(--r-selection-color);
  background: var(--r-selection-background-color);
  text-shadow: none;
}

.reveal ::-moz-selection {
  color: var(--r-selection-color);
  background: var(--r-selection-background-color);
  text-shadow: none;
}

.reveal .slides section,
.reveal .slides section > section {
  line-height: 1.3;
  font-weight: inherit;
}

/*********************************************
 * HEADERS
 *********************************************/
.reveal h1,
.reveal h2,
.reveal h3,
.reveal h4,
.reveal h5,
.reveal h6 {
  margin: var(--r-heading-margin);
  color: var(--r-heading-color);
  font-family: var(--r-heading-font);
  font-weight: var(--r-heading-font-weight);
  line-height: var(--r-heading-line-height);
  letter-spacing: var(--r-heading-letter-spacing);
  text-transform: var(--r-heading-text-transform);
  text-shadow: var(--r-heading-text-shadow);
  word-wrap: break-word;
}

.reveal h1 {
  font-size: var(--r-heading1-size);
}

.reveal h2 {
  font-size: var(--r-heading2-size);
}

.reveal h3 {
  font-size: var(--r-heading3-size);
}

.reveal h4 {
  font-size: var(--r-heading4-size);
}

.reveal h1 {
  text-shadow: var(--r-heading1-text-shadow);
}

/*********************************************
 * OTHER
 *********************************************/
.reveal p {
  margin: var(--r-block-margin) 0;
  line-height: 1.3;
}

/* Remove trailing margins after titles */
.reveal h1:last-child,
.reveal h2:last-child,
.reveal h3:last-child,
.reveal h4:last-child,
.reveal h5:last-child,
.reveal h6:last-child {
  margin-bottom: 0;
}

/* Ensure certain elements are never larger than the slide itself */
.reveal img,
.reveal video,
.reveal iframe {
  max-width: 95%;
  max-height: 95%;
}

.reveal strong,
.reveal b {
  font-weight: bold;
}

.reveal em {
  font-style: italic;
}

.reveal ol,
.reveal dl,
.reveal ul {
  display: inline-block;
  text-align: left;
  margin: 0 0 0 1em;
}

.reveal ol {
  list-style-type: decimal;
}

.reveal ul {
  list-style-type: disc;
}

.reveal ul ul {
  list-style-type: square;
}

.reveal ul ul ul {
  list-style-type: circle;
}

.reveal ul ul,
.reveal ul ol,
.reveal ol ol,
.reveal ol ul {
  display: block;
  margin-left: 40px;
}

.reveal dt {
  font-weight: bold;
}

.reveal dd {
  margin-left: 40px;
}

.reveal blockquote {
  display: block;
  position: relative;
  width: 70%;
  margin: var(--r-block-margin) auto;
  padding: 5px;
  font-style: italic;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
}

.reveal blockquote p:first-child,
.reveal blockquote p:last-child {
  display: inline-block;
}

.reveal q {
  font-style: italic;
}

.reveal pre {
  display: block;
  position: relative;
  width: 90%;
  margin: var(--r-block-margin) auto;
  text-align: left;
  font-size: 0.55em;
  font-family: var(--r-code-font);
  line-height: 1.2em;
  word-wrap: break-word;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
}

.reveal code {
  font-family: var(--r-code-font);
  text-transform: none;
  tab-size: 2;
}

.reveal pre code {
  display: block;
  padding: 5px;
  overflow: auto;
  max-height: 400px;
  word-wrap: normal;
}

.reveal .code-wrapper {
  white-space: normal;
}

.reveal .code-wrapper code {
  white-space: pre;
}

.reveal table {
  margin: auto;
  border-collapse: collapse;
  border-spacing: 0;
}

.reveal table th {
  font-weight: bold;
}

.reveal table th,
.reveal table td {
  text-align: left;
  padding: 0.2em 0.5em 0.2em 0.5em;
  border-bottom: 1px solid;
}

.reveal table th[align=center],
.reveal table td[align=center] {
  text-align: center;
}

.reveal table th[align=right],
.reveal table td[align=right] {
  text-align: right;
}

.reveal table tbody tr:last-child th,
.reveal table tbody tr:last-child td {
  border-bottom: none;
}

.reveal sup {
  vertical-align: super;
  font-size: smaller;
}

.reveal sub {
  vertical-align: sub;
  font-size: smaller;
}

.reveal small {
  display: inline-block;
  font-size: 0.6em;
  line-height: 1.2em;
  vertical-align: top;
}

.reveal small * {
  vertical-align: top;
}

.reveal img {
  margin: var(--r-block-margin) 0;
}

/*********************************************
 * LINKS
 *********************************************/
.reveal a {
  color: var(--r-link-color);
  text-decoration: none;
  transition: color 0.15s ease;
}

.reveal a:hover {
  color: var(--r-link-color-hover);
  text-shadow: none;
  border: none;
}

.reveal .roll span:after {
  color: #fff;
  background: var(--r-link-color-dark);
}

/*********************************************
 * Frame helper
 *********************************************/
.reveal .r-frame {
  border: 4px solid var(--r-main-color);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}

.reveal a .r-frame {
  transition: all 0.15s linear;
}

.reveal a:hover .r-frame {
  border-color: var(--r-link-color);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.55);
}

/*********************************************
 * NAVIGATION CONTROLS
 *********************************************/
.reveal .controls {
  color: var(--r-link-color);
}

/*********************************************
 * PROGRESS BAR
 *********************************************/
.reveal .progress {
  background: rgba(0, 0, 0, 0.2);
  color: var(--r-link-color);
}

/*********************************************
 * PRINT BACKGROUND
 *********************************************/
@media print {
  .backgrounds {
    background-color: var(--r-background-color);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/reveal.js/dist/theme/sky.css"],"names":[],"mappings":"AAAA;;;;EAIE;AAGF;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;8CAE8C;AAC9C;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,8BAA8B;EAC9B,uCAAuC;EACvC,uBAAuB;EACvB,4BAA4B;EAC5B,mCAAmC;EACnC,qCAAqC;EACrC,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,uCAAuC;EACvC,yBAAyB;EACzB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,gFAAgF;EAChF,iIAAiI;EACjI,mFAAmF;EACnF,8EAA8E;EAC9E,+EAA+E;EAC/E,2EAA2E;EAC3E,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;8CAE8C;AAC9C;;;;;;EAME,+BAA+B;EAC/B,6BAA6B;EAC7B,kCAAkC;EAClC,yCAAyC;EACzC,yCAAyC;EACzC,+CAA+C;EAC/C,+CAA+C;EAC/C,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;8CAE8C;AAC9C;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;;;;;;EAME,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;;;EAGE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;8CAE8C;AAC9C;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;;8CAE8C;AAC9C;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;;8CAE8C;AAC9C;EACE,0BAA0B;AAC5B;;AAEA;;8CAE8C;AAC9C;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;8CAE8C;AAC9C;EACE;IACE,2CAA2C;EAC7C;AACF","sourcesContent":["/**\n * Sky theme for reveal.js.\n *\n * Copyright (C) 2011-2012 Hakim El Hattab, http://hakim.se\n */\n@import url(https://fonts.googleapis.com/css?family=Quicksand:400,700,400italic,700italic);\n@import url(https://fonts.googleapis.com/css?family=Open+Sans:400italic,700italic,400,700);\n.reveal a {\n  line-height: 1.3em;\n}\n\nsection.has-dark-background, section.has-dark-background h1, section.has-dark-background h2, section.has-dark-background h3, section.has-dark-background h4, section.has-dark-background h5, section.has-dark-background h6 {\n  color: #fff;\n}\n\n/*********************************************\n * GLOBAL STYLES\n *********************************************/\n:root {\n  --r-background-color: #f7fbfc;\n  --r-main-font: Open Sans, sans-serif;\n  --r-main-font-size: 40px;\n  --r-main-color: #333;\n  --r-block-margin: 20px;\n  --r-heading-margin: 0 0 20px 0;\n  --r-heading-font: Quicksand, sans-serif;\n  --r-heading-color: #333;\n  --r-heading-line-height: 1.2;\n  --r-heading-letter-spacing: -0.08em;\n  --r-heading-text-transform: uppercase;\n  --r-heading-text-shadow: none;\n  --r-heading-font-weight: normal;\n  --r-heading1-text-shadow: none;\n  --r-heading1-size: 3.77em;\n  --r-heading2-size: 2.11em;\n  --r-heading3-size: 1.55em;\n  --r-heading4-size: 1em;\n  --r-code-font: monospace;\n  --r-link-color: #3b759e;\n  --r-link-color-dark: #264c66;\n  --r-link-color-hover: #74a7cb;\n  --r-selection-background-color: #134674;\n  --r-selection-color: #fff;\n  --r-overlay-element-bg-color: 0, 0, 0;\n  --r-overlay-element-fg-color: 240, 240, 240;\n}\n\n.reveal-viewport {\n  background: #add9e4;\n  background: -moz-radial-gradient(center, circle cover, #f7fbfc 0%, #add9e4 100%);\n  background: -webkit-gradient(radial, center center, 0px, center center, 100%, color-stop(0%, #f7fbfc), color-stop(100%, #add9e4));\n  background: -webkit-radial-gradient(center, circle cover, #f7fbfc 0%, #add9e4 100%);\n  background: -o-radial-gradient(center, circle cover, #f7fbfc 0%, #add9e4 100%);\n  background: -ms-radial-gradient(center, circle cover, #f7fbfc 0%, #add9e4 100%);\n  background: radial-gradient(center, circle cover, #f7fbfc 0%, #add9e4 100%);\n  background-color: var(--r-background-color);\n}\n\n.reveal {\n  font-family: var(--r-main-font);\n  font-size: var(--r-main-font-size);\n  font-weight: normal;\n  color: var(--r-main-color);\n}\n\n.reveal ::selection {\n  color: var(--r-selection-color);\n  background: var(--r-selection-background-color);\n  text-shadow: none;\n}\n\n.reveal ::-moz-selection {\n  color: var(--r-selection-color);\n  background: var(--r-selection-background-color);\n  text-shadow: none;\n}\n\n.reveal .slides section,\n.reveal .slides section > section {\n  line-height: 1.3;\n  font-weight: inherit;\n}\n\n/*********************************************\n * HEADERS\n *********************************************/\n.reveal h1,\n.reveal h2,\n.reveal h3,\n.reveal h4,\n.reveal h5,\n.reveal h6 {\n  margin: var(--r-heading-margin);\n  color: var(--r-heading-color);\n  font-family: var(--r-heading-font);\n  font-weight: var(--r-heading-font-weight);\n  line-height: var(--r-heading-line-height);\n  letter-spacing: var(--r-heading-letter-spacing);\n  text-transform: var(--r-heading-text-transform);\n  text-shadow: var(--r-heading-text-shadow);\n  word-wrap: break-word;\n}\n\n.reveal h1 {\n  font-size: var(--r-heading1-size);\n}\n\n.reveal h2 {\n  font-size: var(--r-heading2-size);\n}\n\n.reveal h3 {\n  font-size: var(--r-heading3-size);\n}\n\n.reveal h4 {\n  font-size: var(--r-heading4-size);\n}\n\n.reveal h1 {\n  text-shadow: var(--r-heading1-text-shadow);\n}\n\n/*********************************************\n * OTHER\n *********************************************/\n.reveal p {\n  margin: var(--r-block-margin) 0;\n  line-height: 1.3;\n}\n\n/* Remove trailing margins after titles */\n.reveal h1:last-child,\n.reveal h2:last-child,\n.reveal h3:last-child,\n.reveal h4:last-child,\n.reveal h5:last-child,\n.reveal h6:last-child {\n  margin-bottom: 0;\n}\n\n/* Ensure certain elements are never larger than the slide itself */\n.reveal img,\n.reveal video,\n.reveal iframe {\n  max-width: 95%;\n  max-height: 95%;\n}\n\n.reveal strong,\n.reveal b {\n  font-weight: bold;\n}\n\n.reveal em {\n  font-style: italic;\n}\n\n.reveal ol,\n.reveal dl,\n.reveal ul {\n  display: inline-block;\n  text-align: left;\n  margin: 0 0 0 1em;\n}\n\n.reveal ol {\n  list-style-type: decimal;\n}\n\n.reveal ul {\n  list-style-type: disc;\n}\n\n.reveal ul ul {\n  list-style-type: square;\n}\n\n.reveal ul ul ul {\n  list-style-type: circle;\n}\n\n.reveal ul ul,\n.reveal ul ol,\n.reveal ol ol,\n.reveal ol ul {\n  display: block;\n  margin-left: 40px;\n}\n\n.reveal dt {\n  font-weight: bold;\n}\n\n.reveal dd {\n  margin-left: 40px;\n}\n\n.reveal blockquote {\n  display: block;\n  position: relative;\n  width: 70%;\n  margin: var(--r-block-margin) auto;\n  padding: 5px;\n  font-style: italic;\n  background: rgba(255, 255, 255, 0.05);\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);\n}\n\n.reveal blockquote p:first-child,\n.reveal blockquote p:last-child {\n  display: inline-block;\n}\n\n.reveal q {\n  font-style: italic;\n}\n\n.reveal pre {\n  display: block;\n  position: relative;\n  width: 90%;\n  margin: var(--r-block-margin) auto;\n  text-align: left;\n  font-size: 0.55em;\n  font-family: var(--r-code-font);\n  line-height: 1.2em;\n  word-wrap: break-word;\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);\n}\n\n.reveal code {\n  font-family: var(--r-code-font);\n  text-transform: none;\n  tab-size: 2;\n}\n\n.reveal pre code {\n  display: block;\n  padding: 5px;\n  overflow: auto;\n  max-height: 400px;\n  word-wrap: normal;\n}\n\n.reveal .code-wrapper {\n  white-space: normal;\n}\n\n.reveal .code-wrapper code {\n  white-space: pre;\n}\n\n.reveal table {\n  margin: auto;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n.reveal table th {\n  font-weight: bold;\n}\n\n.reveal table th,\n.reveal table td {\n  text-align: left;\n  padding: 0.2em 0.5em 0.2em 0.5em;\n  border-bottom: 1px solid;\n}\n\n.reveal table th[align=center],\n.reveal table td[align=center] {\n  text-align: center;\n}\n\n.reveal table th[align=right],\n.reveal table td[align=right] {\n  text-align: right;\n}\n\n.reveal table tbody tr:last-child th,\n.reveal table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.reveal sup {\n  vertical-align: super;\n  font-size: smaller;\n}\n\n.reveal sub {\n  vertical-align: sub;\n  font-size: smaller;\n}\n\n.reveal small {\n  display: inline-block;\n  font-size: 0.6em;\n  line-height: 1.2em;\n  vertical-align: top;\n}\n\n.reveal small * {\n  vertical-align: top;\n}\n\n.reveal img {\n  margin: var(--r-block-margin) 0;\n}\n\n/*********************************************\n * LINKS\n *********************************************/\n.reveal a {\n  color: var(--r-link-color);\n  text-decoration: none;\n  transition: color 0.15s ease;\n}\n\n.reveal a:hover {\n  color: var(--r-link-color-hover);\n  text-shadow: none;\n  border: none;\n}\n\n.reveal .roll span:after {\n  color: #fff;\n  background: var(--r-link-color-dark);\n}\n\n/*********************************************\n * Frame helper\n *********************************************/\n.reveal .r-frame {\n  border: 4px solid var(--r-main-color);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);\n}\n\n.reveal a .r-frame {\n  transition: all 0.15s linear;\n}\n\n.reveal a:hover .r-frame {\n  border-color: var(--r-link-color);\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.55);\n}\n\n/*********************************************\n * NAVIGATION CONTROLS\n *********************************************/\n.reveal .controls {\n  color: var(--r-link-color);\n}\n\n/*********************************************\n * PROGRESS BAR\n *********************************************/\n.reveal .progress {\n  background: rgba(0, 0, 0, 0.2);\n  color: var(--r-link-color);\n}\n\n/*********************************************\n * PRINT BACKGROUND\n *********************************************/\n@media print {\n  .backgrounds {\n    background-color: var(--r-background-color);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
